<template>
  <NetworkAlert @retry="retryInitialRequest" />
  <router-view />
  <ShowToast />
  <DynamicDialog />
</template>

<script >
import { defineComponent } from 'vue';
import store from '../src/store';
import NetworkAlert from '@/components/network/NetworkAlert.vue';

export default defineComponent({
  name: 'App',
  components: {
    NetworkAlert
  },
  data() {
    return {
      initialRequestFailed: false
    };
  },
  created() {
    if (Notification.permission !== 'granted') {
      Notification.requestPermission();
    }
  },
  mounted() {
    this.performInitialRequest();
    
    // Écouter les changements de connectivité
    window.addEventListener('online', this.handleOnline);
    window.addEventListener('offline', this.handleOffline);
  },
  beforeUnmount() {
    // Nettoyer les écouteurs d'événements
    window.removeEventListener('online', this.handleOnline);
    window.removeEventListener('offline', this.handleOffline);
  },
  methods: {
    performInitialRequest() {
      store.commit('setIsLoading', true);
      this.axios.get('/sanctum/csrf-cookie')
        .then(() => {
          store.commit('setIsLoading', false);
          this.initialRequestFailed = false;
        })
        .catch((error) => {
          store.commit('setIsLoading', false);
          this.initialRequestFailed = true;
          
          // Distinguer entre une erreur réseau et une autre erreur
          if (error.message === 'Network Error' || !error.response) {
            this.$store.commit('setNetworkError', 'Problème de connexion au serveur. Veuillez vérifier votre connexion Internet.');
          } else {
            this.$toast.add({
              severity: 'error',
              summary: 'Problème de connexion',
              detail: 'Une erreur s\'est produite lors de la connexion au serveur !',
              life: 5000
            });
          }
        });
    },
    retryInitialRequest() {
      if (this.initialRequestFailed) {
        this.performInitialRequest();
      }
    },
    handleOnline() {
      this.$store.dispatch('checkNetworkStatus');
      
      // Si une requête précédente a échoué, réessayer
      if (this.initialRequestFailed) {
        this.performInitialRequest();
      }
    },
    handleOffline() {
      this.$store.dispatch('checkNetworkStatus');
    }
  }
})
</script>

<style lang="scss">
@import './style/app.scss';
</style>